import {Chat} from './Chat.js';
import {ChatSlider} from './ChatSlider.js';
import {Countdown} from './Countdown.js';
import {HeightResize} from './HeightResize.js';
import {Logger} from './Logger.js';
import {Message} from './Message.js';
import {MessageDisplay} from './MessageDisplay.js';
import {Player} from './Player.js';
import {PlayerChat} from './PlayerChat.js';
import {PlayerChatConfig} from './PlayerChatConfig.js';
import {ProxyServers} from './ProxyServers.js';
import {ReloadPopup} from './ReloadPopup.js';
import {RtmpState} from './RtmpState.js';
import {RunAfter} from './RunAfter.js';
import {SendToViewer} from './SendToViewer.js';
import {Talker} from './Talker.js';
import {RoomKeeper} from './RoomKeeper.js';
import {RoomMonitor} from './RoomMonitor.js';
import {VeedoPlayerSizer} from './VeedoPlayerSizer.js';
import {VenueFullPopup} from './VenueFullPopup.js';

/**
 * getPrefix out what prefix our URL is at, given an expected path.
 * For example, if we expect to be at /js/test.js, prefixer will return '/'
 * If we are at /prefix/js/test.js, then prefixer will return '/prefix/'
 * You don't have to specify the last element exactly (ie test.js), it
 * is simply concerned with the number of elements.
 * It returns { Prefix: '', Origin: '' }
 */
function getPrefix(script, expectedPath) {
	const url = new URL(script.src);
	// I know that our prefix will end in /js/all.*
	const pathParts = url.pathname.split(`/`);
	const prefix = pathParts.toSpliced(pathParts.length-expectedPath.split(`/`).length+1).join(`/`) + "/";
	return {
		'Prefix' : prefix,
		'Origin' : url.origin
	}
}

export class Public {
	// static var Prefix;
	static init(script) {
		const prefix = getPrefix(script, '/js/all.js'); // actual name of js script unimportant
		// console.log(`getPrefix = `, prefix);
		Public.Prefix = prefix.Prefix;		
		Public.prefixListeners.map(r => r(Public.Prefix) );
		Public.prefixListeners = [];
		window.DisableVeedoPlayer = true;
		new PlayerChat(document.getElementById(`PlayerChat`));
		Countdown.init();
		RoomKeeper.init();
	}
	static getPrefix() {
		if (Public.Prefix) {
			return Promise.resolve(Public.Prefix);
		}
		return new Promise( (resolve, _)=>{
			Public.prefixListeners.push(resolve);
		});
	}
}
Public.prefixListeners = [];

if (document.readyState=='complete') {
	Public.init(document.currentScript);
} else {
	(function(cs) {
		// console.log(`scheduling Public.init with currentScript = `, cs);
		document.addEventListener('DOMContentLoaded', function() {
			Public.init(cs);
		});
	})(document.currentScript);
}